module.exports = __webpack_public_path__ + "img/246.Explain_process.1eddf06c.svg";